<template>
  <div class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">
    <div class="out">
      <!-- <img src="../../imges/left_logo.png" style="float:left;height:43.875px;margin-top: 10.5625px;margin-left:18.6875px;" /> -->
      <div style="margin-right:30px;display:flex;">
        <img src="../../imges/face.png" style="height:34px;" />
        <div style="color: #616161;margin-left:15px;font-size:15px;line-height:34px;">
          {{name}}
        </div>
      </div>
      <div @click="logout">
        <div class="exitIcon" src="" style=""></div>
      </div>

      <!-- <div style="float:right">
				  <img src="../../imges/xx.jpg"  style="float:right;height:64px;"/>
			</div> -->
    </div>

    <sidebar class="sidebar-container" style="z-index:2000"></sidebar>
    <div class="main-container" style="background-color:#EAEDF7;padding-bottom:10px">
      <div style="position:absolute;right:2%;top: 15px;z-index: 2000;color:#ff0000;width:400px"></div>
      <!-- <div class="user-navbar">
				<navbar></navbar>
			</div> -->

      <!-- <div style="padding:0.3vw;"> -->
      <!-- <div class="user-main"> -->

      <div style="margin:20px 20px">
        <div class="user-main">
          <!-- <div >
				<div class="user-main"> -->
          <app-main></app-main>
        </div>
      </div>

    </div>

    <el-dialog :visible.sync="dialogVisible" width="80%" custom-class="cla1" :before-close="handleClose">
      <iframe ref="xxinfo" seamless width="100%" style="height:59vh;" :src="iframUrl" frameborder="0"></iframe>
    </el-dialog>

  </div>

</template>

<script>
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import AppMain from './AppMain';

import Cookies from 'js-cookie'
import { getToken, setToken, removeToken, getAllCookie } from '../../util/auth';
import {
  mapGetters
} from 'vuex';


import config from "../../../config/config";
const fileShowUrl = config.fileShowUrl;

export default {
  // name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
  },
  computed: {
    sidebar () {
      // sidebar.opened = true
      return this.$store.state.app.sidebar;
    },
    ...mapGetters([
      'sidebar',
      // 'name',
      'avatar'
    ])
  },
  data () {
    return {
      // name:'',
      dialogVisible: false,
      FQRBM: '',
      TSTAMP: '',
      BT: '',
      TZNR: '',
      WJM: '',
      WJLJ: '',
      vueUrl: config.vueUrl,
      iframUrl: config.vueUrl + 'Tzgg',
      name: "",
      ss2: "",
    }
  },
  created () {
    var that = this;
    var newsId = localStorage.getItem('newsId');
    if (newsId != '' && newsId != null && newsId != undefined) {
      getCbdDetail({ XXID: newsId }).then((res) => {
        if (res.status == 'success') {
          if (res.data.outmap.cbdDetail != '' && res.data.outmap.cbdDetail != null) {
            that.dialogVisible = true;
          }
        }

      });
    }
    this.cre1();
  },
  mounted () {
    window.xxinfo = this.xxinfo;
  },
  methods: {
    cre1 () {
      var that = this;
      this.ss2 = setInterval(function () {
        that.name = localStorage.getItem("Name");
        //that.name = '管理员';

        if (that.name != null && that.name != undefined && that.name != "") {
          that.cre2();
        }
      }, 1000);
    },
    cre2 () {
      clearInterval(this.ss2);
    },
    //操作说明点击事件
    tiaozhuan () {
      this.$router.push({ path: '/sysm/smxq' });
    },
    handleClose () {
      this.iframUrl = "";
      this.dialogVisible = false;
    },
    xxinfo (newsId) {
      this.iframUrl = config.vueUrl + 'Tzgg';
      //	this.$refs.xxinfo.contentWindow.location.href=this.iframUrl;

      localStorage.setItem('newsId', newsId);

      this.dialogVisible = true;

    },
    openfile () {
      window.open(fileShowUrl + this.WJLJ);

    },
    logout () {
      this.$confirm('确认要退出登录吗', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {

          localStorage.removeItem("code")
          localStorage.removeItem("No")
          localStorage.removeItem("Name")
          localStorage.removeItem("FK_Dept")
          localStorage.removeItem("FK_DeptName")
          localStorage.removeItem("Type")
          localStorage.removeItem("userId")

          //removeToken()
          // sessionStorage.clear()
          // Cookies.remove('No');
          // Cookies.remove('Name');
          // Cookies.remove('FK_Dept');
          // Cookies.remove('FK_DeptName');
          // Cookies.remove('SID');
          location.replace('https://sso.xmist.edu.cn/ssox/force/logout?service=http://172.17.88.49/cjrh-api/sso/glLogin')
          //	 location.replace('https://appzb.fjcpc.edu.cn/mwcztymh/system/login.do')
        })
        .catch(action => {

        });
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.out {
  display: flex;
  justify-content: right;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 65px;
  background: white;
  z-index: 2000;
  box-shadow: 0 1px 4px 0px #bdbdbd;
  padding-right: 20px !important;
}
.exitIcon {
  cursor: pointer;
  height: 20px;
  width: 20px;
  background: url(../../imges/out.png);
  background-size: cover;
}
.exitIcon:hover {
  background: url(../../imges/out-on.png);
  background-size: cover;
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.hideSidebar {
    .sidebar-container {
      width: 48px;
      padding: 0 !important;
      overflow: inherit;
    }

    .main-container {
      margin-left: 48px;
      // margin-top: 60px;
    }
  }

  .sidebar-container {
    transition: width 0.28s ease-out;
    width: 14vw;
    // height: 93%;
    min-height: 100%;
    position: fixed;
    // top: 70px;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .main-container {
    min-height: 100%;
    transition: margin-left 0.28s ease-out;
    margin-left: 14vw;
    padding-top: 62px;
  }

  .imgPic {
    width: 100%;
    overflow: hidden;
    height: 70px;
    line-height: 70px;
    background-color: #0075b8;
    position: fixed;
    height: auto;
    overflow-y: auto;
    z-index: 1001;
  }

  .user-navbar {
    position: fixed;
    width: 100%;
    height: auto;
    overflow-y: auto;
    overflow: hidden;
    z-index: 1001;
    // top: 70px;
    top: 65px;
  }
  .user-navbar2 {
    position: fixed;
    width: 100%;
    height: auto;
    overflow-y: auto;
    overflow: hidden;
    z-index: 1001;
    // top: 70px;
    top: 65px;
  }

  .user-main {
    // padding-top: 59px;
    // margin-top: 65px;
    background: white;
  }

  // .user-avatar {
  // 	width: 40px;
  // 	height: 40px;
  // 	border-radius: 10px;
  // }

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    position: absolute;
    margin-top: 15px;
  }

  * {
    margin: 0;
    padding: 0;
  }
  html,
  body {
    height: 100%;
  }
  .linkeytable table {
    border-collapse: collapse;
    border: 1px solid #000;
    word-wrap: break-word;
    word-break: break-all;
  }
  .linkeytable td {
    border-collapse: collapse;
    border: 1px solid #000;
    padding: 4px;
    font-size: 12pt;
    font-family: "宋体", "Arial";
  }
  .linkeytable td.texttd {
    text-align: right;
    background: #f1f7fe;
    font-size: 12pt;
    font-family: "宋体", "Arial";
  }
  .linkeytable {
    vertical-align: middle;
    margin: 0 auto;
    width: 80%;
  }
  .linkeytable caption {
    text-align: center;
    padding: 20px;
    font-size: 32pt;
    font-weight: bold;
    font-family: "楷体", Arial;
  }
  .linkeytable tr th {
    width: 15%;
    text-align: right;
  }
  .paper p {
    margin: 10px 0;
  }
  .fileitem {
    font-size: 16px;
    padding-left: 20px;
    margin: 0.5vw 0;
  }
  .curp {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue